var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActorSelectedTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#00B2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6186 7.18726L8.34206 14.0539C7.93689 14.4377 7.29903 14.4268 6.90725 14.0293L4.47524 11.5737C4.21041 11.315 4.10569 10.9336 4.20129 10.5759C4.2969 10.2182 4.57796 9.93995 4.93655 9.84789C5.29514 9.75583 5.67551 9.86433 5.93158 10.1317L7.6554 11.874L14.2094 5.6971C14.4756 5.44538 14.8559 5.35478 15.207 5.45945C15.5581 5.56411 15.8267 5.84813 15.9116 6.20452C15.9965 6.56092 15.8848 6.93553 15.6186 7.18726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActorSelectedTick);
export default __webpack_public_path__ + "static/media/actor_selected_tick.0d3a98928b16896eb2f4dd4d74246077.svg";
export { ForwardRef as ReactComponent };